import React from 'react';
import { AnchorText } from '../../common';
import styled from 'styled-components';
import tw from 'twin.macro';

const StyledNavListItems = styled.li`
  ${tw`cursor-pointer transition-all duration-200 font-semibold text-lg`}
  color: ${(props) => props.$color} !important;
  &:hover {
    color: ${(props) => props.$colorHover} !important;
  }
  & svg {
    ${tw`h-4 w-4`}
  }
  & a {
    color: ${(props) => props.$color} !important;
    ${tw`transition-all duration-200 font-semibold text-lg`}
    &:hover {
      color: ${(props) => props.$colorHover} !important;
    }
  }
`;

const NavbarPrimarySingleNavItem = ({ nav, page, sanity }) => {
  const { colors } = sanity;
  return (
    <StyledNavListItems
      key={nav?.singlePageLink?.slug?.current}
      $color={colors?.neutral?.dark}
      $colorHover={colors?.accent?.default}
    >
      <AnchorText
        sanity={sanity}
        type="internal"
        color={colors?.neutral?.default}
        to={nav?.singlePageLink?.slug?.current}
      >
        {nav?.singlePageLink?.name}
      </AnchorText>
    </StyledNavListItems>
  );
};

export { NavbarPrimarySingleNavItem };
